import { motion, useTransform, useViewportScroll } from 'framer-motion';
import React from 'react';
import { attributesType, tabsType } from '../libs/typeInterface';
import AboutProduct from './AboutProduct';
import WhatIsIn from './WhatIsIn';

interface IMiddleSection {
  productSelected: string;
  tabs: tabsType[];
  inside: attributesType[];
}

const MiddleSection = (props: IMiddleSection) => {
  const { productSelected, tabs, inside } = props;

  let scaleAnim;
  let yPosAnim;
  let xPosAnim;

  const { scrollYProgress } = useViewportScroll();

  if (productSelected === 'serum') {
    scaleAnim = useTransform(scrollYProgress, [0, 0.1, 1], [0, 0.01, 1.5]);
    yPosAnim = useTransform(scrollYProgress, [2500, 1.3, 0], [0, 2900, -480]);
    xPosAnim = useTransform(scrollYProgress, [450, 1.5, 0], [1, 0, 150]);
  }

  if (productSelected === 'facewash') {
    scaleAnim = useTransform(scrollYProgress, [0, 0.1, 1], [0, 0.01, 1]);
    yPosAnim = useTransform(scrollYProgress, [2100, 2, 0], [3000, 3500, -550]);
    xPosAnim = useTransform(scrollYProgress, [450, 1.5, 0], [1, 0, 100]);
  }

  if (productSelected === 'cream') {
    scaleAnim = useTransform(scrollYProgress, [0, 0.1, 1], [0, 0.0, 1.5]);
    yPosAnim = useTransform(scrollYProgress, [2500, 1.3, 0], [0, 2900, -450]);
    xPosAnim = useTransform(scrollYProgress, [450, 1.5, 0], [1, 0, 150]);
  }

  return (
    <>
      <div className="lg:mt-20 w-full flex justify-center flex-wrap relative overflow-hidden">
        <AboutProduct productSelected={productSelected} tabs={tabs} />
        <motion.div
          className="xs:hidden lg:block lg:absolute"
          style={{
            scale: scaleAnim,
            x: xPosAnim,
            y: yPosAnim
          }}
        >
          {productSelected === 'serum' && (
            <img src="/images/serum-drop.png" className="relative w-full h-full object-contain" />
          )}
          {productSelected === 'facewash' && (
            <img
              src="/images/facewash-drop.png"
              className="relative w-full h-full object-contain"
            />
          )}
          {productSelected === 'cream' && (
            <img src="/images/cream-drop.png" className="relative w-full h-full object-contain" />
          )}
        </motion.div>
        <WhatIsIn product={productSelected} inside={inside} />
      </div>
    </>
  );
};

export default MiddleSection;
